import React, { useEffect, useState } from "react";
import AuthLayout from "../Layout/AuthLayout";
import _ from "lodash";
import * as actions from "../../actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PartnerSignupForm from "./PartnerSignupForm";

import { Col } from "reactstrap";

import { renderErrorsAsList, getPartnerTypes } from "../misc/functions";

const PartnerSignupPage = (props) => {
  const [state, setState] = useState({
    username: "",
    password: "",
    password_confirmation: "",
    first_name: "",
    last_name: "",
    company_name: "",
    company_country_id: "",
    phone: "",
    partner_type_id: 2,
    selected_partner_type_id: "",
    steaman_commerce_partner_terms: false,
    selected_country_id: "selected_country_id",
  });

  const handleSignup = (e) => {
    e.preventDefault();
    props.actions.partner_signup(
      state.first_name,
      state.last_name,
      state.username,
      state.email,
      state.phone,
      state.company_name,
      state.password,
      state.password_confirmation,
      state.partner_type_id,
      state.steaman_commerce_partner_terms
    );
  };
  const onChange = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };
  const onPhoneChange = (phone) => {
    setState({
      ...state,
      phone: phone,
    });
  };

  const handleChangeToggle = (component) => {
    setState({
      ...state,
      [component.target.name]: component.target.checked,
    });
  };

  const handleChangeSelect = (selectedOption, val) => {
    setState({
      ...state,
      [selectedOption]: val.value,
      [`selected_${selectedOption}`]: val,
    });
  };

  useEffect(() => {
    getPartnerTypes().then((response) => {
      setState({
        ...state,
        partner_types: response,
      });
    });
  }, []);
  return (
    <AuthLayout>
      <div className="row authDiv">
        <div className="col-md-12 header">
          <h2 className="col-md-12">
            {" "}
            {!_.isEmpty(props.authentication.signupSuccessMessage)
              ? "Account Succesfully Created"
              : "Create a Partner Account"}
          </h2>

          {!_.isEmpty(props.authentication.signupErrorMessage) ? (
            <Col md={12}>
              <div class="alert alert-danger " role="alert">
                {" "}
                <p>The Following errors occured during signup</p>{" "}
                {renderErrorsAsList(props.authentication.signupErrorMessage)}
              </div>
            </Col>
          ) : (
            ""
          )}
          {!_.isEmpty(props.authentication.signupSuccessMessage) ? (
            <div class="alert alert-success " role="alert">
              {" "}
              <p>{props.authentication.signupSuccessMessage} </p>{" "}
            </div>
          ) : (
            ""
          )}
        </div>
        <Col md={12}>
          {!_.isEmpty(props.authentication.signupSuccessMessage) ? (
            ""
          ) : (
            <PartnerSignupForm
              id="SignupBox"
              {...state}
              onPhoneChange={onPhoneChange}
              handleChangeToggle={handleChangeToggle}
              onChange={onChange}
              signup={handleSignup}
              handleChangeSelect={handleChangeSelect}
              countries={state.countries}
            />
          )}
        </Col>
      </div>
    </AuthLayout>
  );
};

const mapStateToProps = (state) => ({ authentication: state.authentication });
const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(PartnerSignupPage);
